import { createFileRoute, Link } from "@tanstack/react-router";
import { AppTabList, type TabType } from "@components/AppTabList.tsx";
import CampaignForm from "@components/campaigns/CampaignForm.tsx";
import AppCard from "@components/AppCard.tsx";
import { TabContext, TabPanel } from "@mui/lab";
import { Tab } from "@mui/material";
import { useCurrentCampaign } from "@contexts/CampaignContext.tsx";
import ModulesDataGrid from "@components/modules/datagrid/ModulesDataGrid.tsx";
import ParticipantTab from "@components/campaigns/ParticipantTab.tsx";
import { Icon } from "@iconify/react";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN } from "@/constants";

export const Route = createFileRoute("/_dashboard/campaigns/$uuid/$tab")({
  beforeLoad: (args) => {
    requireRole([ROLE_ADMIN])(args);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const campaign = useCurrentCampaign();

  const TABS: TabType[] = [
    {
      label: "Informations",
      value: "overview",
      href: `/campaigns/${campaign.uuid}/overview`,
      icon: "tabler:file-text",
      children: (
        <AppCard>
          <CampaignForm />
        </AppCard>
      ),
    },
    {
      label: "Modules",
      value: "modules",
      href: `/campaigns/${campaign.uuid}/modules`,
      icon: "tabler:box",
      children: (
        <AppCard>
          <ModulesDataGrid
            campaign={campaign}
            customRequestParams={{
              ["campaign.uuid"]: campaign.uuid,
            }}
          />
        </AppCard>
      ),
    },
    {
      label: "Participants",
      value: "participants",
      href: `/campaigns/${campaign.uuid}/participants`,
      icon: "tabler:users",
      children: (
        <AppCard>
          <ParticipantTab campaignUuid={campaign.uuid} />
        </AppCard>
      ),
    },
  ];

  const { tab } = Route.useParams();

  return (
    <TabContext value={tab}>
      <AppTabList>
        {TABS.map((tab) => (
          <Tab
            component={Link}
            key={tab.value}
            label={tab.label}
            value={tab.value}
            href={tab.href ?? tab.value}
            {...(tab.icon && {
              icon: <Icon fontSize="18" icon={tab.icon} />,
            })}
            iconPosition={"start"}
          />
        ))}
      </AppTabList>
      {TABS.map((tab) => (
        <TabPanel
          value={tab.value}
          key={tab.value}
          sx={{
            padding: 0,
          }}
        >
          {tab.children}
        </TabPanel>
      ))}
    </TabContext>
  );
}
